import {
    CREATE_GENERAL_PO_MASTER_REQUEST,
    CREATE_GENERAL_PO_MASTER_SUCCESS,
    CREATE_GENERAL_PO_MASTER_FAILURE,
    DELETE_GENERAL_PO_MASTER_REQUEST,
    DELETE_GENERAL_PO_MASTER_SUCCESS,
    DELETE_GENERAL_PO_MASTER_FAILURE,
    FETCH_SINGLE_GENERAL_PO_MASTER_REQUEST,
    FETCH_SINGLE_GENERAL_PO_MASTER_SUCCESS,
    FETCH_SINGLE_GENERAL_PO_MASTER_FAILURE,
    FETCH_GENERAL_PO_MASTER_REQUEST,
    FETCH_GENERAL_PO_MASTER_SUCCESS,
    FETCH_GENERAL_PO_MASTER_FAILURE,
    UPDATE_GENERAL_PO_MASTER_REQUEST,
    UPDATE_GENERAL_PO_MASTER_SUCCESS,
    UPDATE_GENERAL_PO_MASTER_FAILURE,
    RESET_GENERAL_PO_MASTER_INFO,
    CREATE_GENERAL_PO_MASTER_FORM,
    UPDATE_GENERAL_PO_MASTER_FORM,
    NAVIGATE_GENERAL_PO_DETAILS,
    NAVIGATE_GENERAL_PO_MASTER,
    FETCH_GENERAL_PO_MASTER_INVOICE_REQUEST,
    FETCH_GENERAL_PO_MASTER_INVOICE_SUCCESS,
    FETCH_GENERAL_PO_MASTER_INVOICE_FAILURE,
    RESET_GENERAL_PO_MASTER_INVOICE,
    GENERAL_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    NAVIGATE_TO_DETAIL_TAB,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_GENERAL_PO_MASTER_PRINT,
    FETCH_SAMPLE_PO_PROGRAM_LIST_REQUEST,
    FETCH_SAMPLE_PO_PROGRAM_LIST_SUCCESS,
    FETCH_SAMPLE_PO_PROGRAM_LIST_FAILURE
} from './generalPoMaster.actionsType';

export const GENERAL_PO_MASTER = 'generalPoMaster';

let initialState = {
    loading: false,
    generalPoInvoiceV2: [],
    generalPoMaster: [],
    userform: {
        fldFKDeliveryAt: '', fldFKSupplierID: '', showInputField: false,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedState: {},
    errorMessage: '',
    singleGeneralPoData: {},
    isGeneralPoDetails: false,
    detailsId: '',
    activeKey: 1,
    headerSearchCall: true,
};

export let generalPoMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_GENERAL_PO_MASTER_REQUEST:
        case CREATE_GENERAL_PO_MASTER_REQUEST:
        case UPDATE_GENERAL_PO_MASTER_REQUEST:
        case FETCH_SINGLE_GENERAL_PO_MASTER_REQUEST:
        case DELETE_GENERAL_PO_MASTER_REQUEST:
        case FETCH_GENERAL_PO_MASTER_INVOICE_REQUEST:
        case FETCH_SAMPLE_PO_PROGRAM_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoMaster: updatePayload
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case CREATE_GENERAL_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '', fldFKSupplierID: '', fldIsInHouseDelivery: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };
        case UPDATE_GENERAL_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '', fldFKSupplierID: '', fldIsInHouseDelivery: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            };
        case FETCH_SINGLE_GENERAL_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload, showInputField: updatePayload?.fldFKSaleOrder !== 0 ? false : true, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }
            };
        case FETCH_GENERAL_PO_MASTER_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInvoiceV2: updatePayload
            };
        case DELETE_GENERAL_PO_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '', fldIsInHouseDelivery: false },
                detailsId: ''
            };
        case RESET_GENERAL_PO_MASTER_INFO:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldFKUnitId: 0,
                    fldFKSection: 0,
                    fldFKProgram: 0,
                    fldFKTypeofPO: 0,
                    fldFKSource: 0,
                    fldFKSeason: 0,
                    fldFKDepartment: 0,
                    fldFKPaymentTerms: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: '',
                activeKey: 1

            };
        case RESET_GENERAL_PO_MASTER_INVOICE:
            return {
                ...state,
                generalPoInvoiceV2: []
            };
        case FETCH_SAMPLE_PO_PROGRAM_LIST_SUCCESS:
            return {
                ...state,
                samplePOList: updatePayload,
            };
        case CREATE_GENERAL_PO_MASTER_FORM:
        case UPDATE_GENERAL_PO_MASTER_FORM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_GENERAL_PO_MASTER_FAILURE:
        case CREATE_GENERAL_PO_MASTER_FAILURE:
        case UPDATE_GENERAL_PO_MASTER_FAILURE:
        case FETCH_SINGLE_GENERAL_PO_MASTER_FAILURE:
        case DELETE_GENERAL_PO_MASTER_FAILURE:
        case FETCH_GENERAL_PO_MASTER_INVOICE_FAILURE:
        case FETCH_SAMPLE_PO_PROGRAM_LIST_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_GENERAL_PO_DETAILS:
            return {
                ...state,
                isGeneralPoDetails: true,
                singleGeneralPoData: updatePayload.singleGeneralPoData
            };
        case NAVIGATE_GENERAL_PO_MASTER:
            return {
                ...state,
                isGeneralPoDetails: false
            };
        case NAVIGATE_GENERAL_PO_MASTER_PRINT:
            return {
                ...state,
                isGeneralPoDetails: false,
                singleGeneralPoData: updatePayload.singleGeneralPoData
            };
        case NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                // isGeneralPoDetails: true,
                activeKey: 2
            }

        case GENERAL_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
